.errorMessage {
  position: relative;
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: var(--ixf-space-2) var(--ixf-space-4);
  color: var(--ixf-color-danger-dk);
  font-weight: var(--ixf-font-weight-main-medium);
  font-family: var(--ixf-font-family-main);
  font-size: 0.875rem;
  line-height: 1.125rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    border-radius: inherit !important;
    background-color: var(--ixf-color-danger-md);
    opacity: 0.2;
    pointer-events: none;
  }
}
